import api from "../Api/axios";
import { ENDPOINTS } from "../Api/endpoints";
import { LoginRequest, LoginResponse } from "../Types/Admin/Login";

export const superAdminService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(
      ENDPOINTS.SUPER_ADMIN_LOGIN,
      credentials
    );
    return response.data;
  },
};
